import { FC, SVGProps } from 'react'

const ShareIcon: FC<SVGProps<SVGSVGElement>> = svgProps => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...svgProps}
  >
    <path
      d="M3.51547 7.66375L2.14435 8.90152C1.06793 9.87326 0.997472 11.5204 1.98699 12.5805V12.5805C2.9765 13.6406 4.65127 13.7122 5.72769 12.7405L8.2275 10.4838C9.43782 9.3912 9.51703 7.53918 8.40444 6.34721V6.34721"
      stroke="currentColor"
      strokeWidth="2"
    />
    <path
      d="M11.0085 7.27952L12.3419 5.96818C13.3655 4.96151 13.3655 3.32938 12.3419 2.32271V2.32271C11.3183 1.31604 9.65864 1.31604 8.63501 2.32271L6.1987 4.71867C5.04775 5.85056 5.04775 7.68571 6.1987 8.81759V8.81759"
      stroke="currentColor"
      strokeWidth="2"
    />
  </svg>
)

export default ShareIcon
